export const dataSelector = (state) => state.admin.properties.data;
export const paginationSelector = (state) => state.admin.properties.pagination;
export const loadingSelector = (state) => state.admin.properties.loading;
export const searchResultCountersSelector = (state) => state.admin.properties.searchResultCounters;
